<i18n>
{
  "en": {
    "hello": "Welcome to Verification System!",
    "message": "Please singup to app with your E-mail.",
    "newRegistration": " sign up.",
    "errorHappend": "Something went wrong :(. I'm sorry to bother you, please try again later.",
    "expired": "The login effective period of this campaign has expired.",
    "campaignNotFound": "This campaign can not be found. Please check if the URL is correct.",
    "nowLoading": "Now loading...",
    "passwordAlert": "We recommend setting a password different from your Instagram account or Twitter account for security.",
    "inquiry1": "If you can not login, please contact us from ",
    "inquiry2": "here",
    "inquiry3": "",
    "maintenance": {
      "inMaintenance": "Currently under system maintenance. <br /> Sorry for your inconvenience, but please access again after the maintenance is completed.",
      "maintenance": "Due to system maintenance, the service will be suspended for the following period.",
      "stopTerm": "[Stop period]",
      "notice": "*Depending on the maintenance work situation, it may be extended."
    }
  },
  "ja": {
    "hello": "手続きシステムへようこそ！",
    "message": "本システム上でご本人さまの確認のための作品データ提出や賞品発送のための情報入力などをしていただきます。まずは、登録用のメールアドレスとパスワードを設定して、手続きシステムアカウントの新規作成をお願いします。",
    "newRegistration": "新規登録",
    "errorHappend": "予期せぬエラーが発生しました。お手数ですが、再度お試しいただくようお願いいたします。",
    "expired": "該当のキャンペーンのログイン有効期間が終了しています。",
    "campaignNotFound": "該当のキャンペーンが見つかりません。URLが正しいかご確認下さい。",
    "nowLoading": "Now loading...",
    "passwordAlert": "セキュリティ上の観点から、パスワードはお持ちのInstagramアカウントやTwitterアカウントと別のパスワードの設定をおすすめします",
    "inquiry1": "※ログインできない場合は",
    "inquiry2": "こちら",
    "inquiry3": "よりお問い合わせください。",
    "maintenance": {
      "inMaintenance": "現在、システムメンテナンス中です。<br />お手数ですが、メンテナンス終了後に再度アクセスしてください。",
      "maintenance": "システムメンテナンスのため、下記期間サービスを停止致します。",
      "stopTerm": "【停止期間】",
      "notice": "※メンテナンス作業の状況によっては、延長させて頂く場合がございます。"
    }
  }
}
</i18n>

<template>
  <v-layout row wrap align-center text-xs-center justify-center>
    <div v-if="loading" class="loader">{{ $t('nowLoading') }}</div>
    <!-- エラー時 -->
    <v-flex v-if="!loading && hasError">
      <v-alert outline :value="signupExpired">
        {{ $t('expired') }}
      </v-alert>
      <v-alert outline :value="campaignNotFound">
        {{ $t('campaignNotFound') }}
      </v-alert>
      <v-alert outline :value="unexpectedError">
        {{ $t('errorHappend') }}
      </v-alert>
    </v-flex>
    <!-- 正常時 -->
    <v-flex
      v-if="!loading && !hasError"
      style=""
      xs12
      sm12
      md6
      lg6
      xl6
      text-xs-left
    >
      <v-flex
        style="justify-content: center;
          text-align: center;
          margin-top: 16px;
          margin-bottom: 32px;"
      >
        <img src="@/assets/title.png" />
      </v-flex>
      <p class="title">{{ $t('hello') }}</p>
      <p class="body-2">{{ $t('message') }}</p>
      <br />
      <div class="maintenance" v-if="isMaintenanceSchedule">
        <span v-if="isMaintenance">
          <strong v-html="$t('maintenance.inMaintenance')"></strong>
        </span>
        <span v-else>
          <strong>{{ $t('maintenance.maintenance') }}</strong>
        </span>
        <br />
        {{ $t('maintenance.stopTerm') }}{{ maintenanceTerm }}<br />
        <small>({{ $t('maintenance.notice') }})</small>
      </div>
      <!-- <p></p> -->
      <v-card v-if="!isMaintenance">
        <div
          style="padding: 16px;
          font-size: 1.2rem;
          color: white;
          background-color: #385168;"
        >
          {{ campaignName + ' ' + $t('newRegistration') }}
        </div>
        <v-card-text>
          <v-alert outline value="true" type="info">
            {{ $t('passwordAlert') }}
          </v-alert>
          <EmailConfirmForm
            :onSubmit="emailConfirm"
            :sourceType="sourceType"
            :privacyPolicyUrl="privacyPolicyUrl"
          />
        </v-card-text>
      </v-card>
      <br />
      <p class="body-2" v-if="!isMaintenance">
        {{ $t('inquiry1') }}
        <a
          :href="`/cp/${this.$route.params.campaignCode}/me/help`"
          target="_blank"
          >{{ $t('inquiry2') }}
        </a>
        {{ $t('inquiry3') }}
      </p>
      <br />
      <br />
    </v-flex>
  </v-layout>
</template>

<script>
import EmailConfirmForm from '@/components/molecules/EmailConfirmForm.vue';
import TokenManager from '@/utils/TokenManager';
import StorageManager from '@/utils/StorageManager';
import { EnumSourceTypes } from '@/enum/enum.js';
import { PERSIST_KEY } from '@/store';
import MaintenanceUtil from '@/utils/MaintenanceUtil';

export default {
  components: {
    EmailConfirmForm
  },
  computed: {
    contactUs() {
      return this.$store.state.current.campaign.contactUrl;
    },
    campaignName() {
      return this.$store.state.current.campaign.name;
    }
  },
  methods: {
    emailConfirm() {}
  },
  data() {
    return {
      loading: true,
      hasError: false,
      errorMessage: '',
      signupExpired: false,
      campaignNotFound: false,
      unexpectedError: false,
      sourceType: '',
      privacyPolicyUrl: '',
      isMaintenance: MaintenanceUtil.isMaintenance(),
      isMaintenanceSchedule: MaintenanceUtil.isMaintenanceSchedule(),
      maintenanceTerm: MaintenanceUtil.maintenanceTerm()
    };
  },
  created() {
    // 既にサインイン済みだけど直リンしてきた場合に対応
    TokenManager.remove();
    this.$store
      .dispatch('prepareByCampaignCode', this.$route.params.campaignCode)
      .then(result => {
        this.sourceType = result.userInfo.sourceType;
        if (this.sourceType === EnumSourceTypes.Instagram) {
          this.privacyPolicyUrl = result.campaign.instagramPrivacyUrl;
        } else if (this.sourceType === EnumSourceTypes.Twitter) {
          this.privacyPolicyUrl = result.campaign.twitterPrivacyUrl;
        }
        // Cookie利用に同意する前のため、利用箇所を明示的に削除する
        StorageManager.removeItem(PERSIST_KEY);
      })
      .catch(error => {
        if (error.http.statusCode === 400 || error.http.statusCode === 404) {
          this.campaignNotFound = true;
        } else if (error.http.statusCode === 403) {
          this.signupExpired = true;
        } else {
          this.unexpectedError = true;
        }
        this.errorMessage = error.message;
        this.hasError = true;
      })
      .finally(() => {
        this.loading = false;
      });
    // メンテナンスが予定されている場合は、メンテナンスフラグを常に更新する
    if (this.isMaintenanceSchedule) {
      setInterval(
        function() {
          this.isMaintenance = MaintenanceUtil.isMaintenance();
          this.isMaintenanceSchedule = MaintenanceUtil.isMaintenanceSchedule();
        }.bind(this),
        1000
      );
    }
  }
};
</script>

<style scoped lang="stylus">
.maintenance {
  width: 100%;
  z-index: 99999;
  background-color: rgba(0,0,0,0);
  text-align: center;
  padding: 8px;
  border: 1px solid #ff0000;
  margin-bottom: 20px;
}
</style>
